export enum Role {
  Root = 'Root',
  Admin = 'Admin',
  GovernmentUser = 'GovernmentUser',
  Observer = 'Observer',
}
